export const ChartLeaderLines = {
    id: 'LeaderLines',
    afterDraw(chart, args, options) {
        const { ctx } = chart;
        chart.data.datasets.forEach((dataset, index) => {
            chart.getDatasetMeta(index).data.forEach((datapoint) => {
                const { x, y, outerRadius, startAngle, endAngle } = datapoint;
                //* Calculate center edge point(x,y) of an arc
                const angleMiddle = (startAngle + endAngle) / 2;
                const circleEdgeX = x + outerRadius * Math.cos(angleMiddle);
                const circleEdgeY = y + outerRadius * Math.sin(angleMiddle);
                //* Calculate center edge point(x,y) of outer arc
                const radius = outerRadius * 1.15;
                const outerEdgeX = x + radius * Math.cos(angleMiddle);
                const outerEdgeY = y + radius * Math.sin(angleMiddle);
                ctx.beginPath();
                ctx.moveTo(circleEdgeX, circleEdgeY);
                ctx.lineTo(outerEdgeX, outerEdgeY);
                ctx.strokeStyle = '#33658A';
                ctx.stroke();
            });
        });
    }
};
